<script setup lang="ts">
  interface PageBreak {
    top: number;
    pageNumber: number;
  }

  interface Props {
    pageBreaks: PageBreak[];
    totalPages: number;
  }

  defineProps<Props>();
</script>

<template>
  <div
    v-for="breakPos in pageBreaks"
    :key="`page-break-${breakPos.pageNumber}`"
    data-testid="page-break"
    class="absolute left-0 right-0 flex justify-end border-t-2 border-dashed border-gray-15 pointer-events-none"
    :style="{ top: `${breakPos.top}px` }"
  >
    <!-- Sticky, not absolute: a landscape sheet is wider than the canvas, and a label pinned to the
         sheet's right edge sits in the part scrolled out of view. -->
    <div class="sticky right-8 mr-8 -mt-3.5 h-0">
      <span
        data-testid="page-break-label"
        class="block whitespace-nowrap bg-gray-100 px-3 py-1 rounded text-xs text-gray-500 font-medium shadow-sm pointer-events-auto"
      >
        Página {{ breakPos.pageNumber }} de {{ totalPages }}
      </span>
    </div>
  </div>
</template>
